import request from "root/js/request";

export const getAnalyticsSubjectsByContent = async ({
  imt_id,
  cabinet_id__in,
  category_id__in,
  brand_id__in,
  ...rest
}) => {
  const response = await request({
    url: "/analytics/subjects/by-content/",
    method: "get",
    params: {
      imt_id,
      cabinet_id__in,
      category_id__in,
      brand_id__in,
      ...rest,
    },
  });
  return response;
};
